import React, { useContext, createContext } from "react";

const storeContext = createContext();
storeContext.displayName = 'Store';

export function ProvideStore({ children, storeData }) {
  const store = useProvideStore(storeData);
  return <storeContext.Provider value={store}>{children}</storeContext.Provider>;
}

export const useStore = () => {
  return useContext(storeContext);
};

function useProvideStore(store) {  
  const add = (key, data) => {
    store.add(key, data);
  };

  const remove = (key) => {
    store.remove(key);
  };

  const get = (key, remove = false) => {
    return store.get(key, remove);
  };
  
  return {
    add,
    remove,
    get
  };
};
